<script setup lang="ts">
// Positioning viewport for toasts. Pure layout — no timers, no queue (those
// live in the app's useToast composable). Rendered once in each app shell;
// the app slots its NoticeToast cards inside. Teleported to body so it floats
// above app chrome regardless of where it's mounted.
</script>

<template>
  <Teleport to="body">
    <TransitionGroup tag="div" name="lumi-toast" class="lumi-toast-host" aria-live="polite">
      <slot />
    </TransitionGroup>
  </Teleport>
</template>

<style>
/* Overlay stacking ladder — tokens/layers.css (workbench < drawer < modal <
   confirm < toast): a toast a modal covers is a toast nobody reads, so it
   stays above every other teleported overlay surface. Keep in step with
   Workbench.vue, Drawer.vue and Modal.vue — never hand-write a z-index here
   (check-raw-layer-usage). */
.lumi-toast-host{position:fixed;top:var(--space-6);right:var(--space-6);z-index:var(--layer-toast);display:flex;flex-direction:column;gap:var(--space-3);pointer-events:none;}
.lumi-toast-host > *{pointer-events:auto;}
.lumi-toast-enter-active,.lumi-toast-leave-active{transition:transform var(--dur-base) var(--ease-standard),opacity var(--dur-base) var(--ease-standard);}
.lumi-toast-enter-from{opacity:0;transform:translateX(16px);}
.lumi-toast-leave-to{opacity:0;transform:translateX(16px);}
.lumi-toast-leave-active{position:absolute;right:0;}
@media (prefers-reduced-motion: reduce){
  .lumi-toast-enter-active,.lumi-toast-leave-active{transition:opacity var(--dur-fast) var(--ease-standard);}
  .lumi-toast-enter-from,.lumi-toast-leave-to{transform:none;}
}
</style>
